import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=8ae4ad98&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports